export default "/images/vendor/flag-icons/flags/1x1/la.svg?b13d502fed498abb9b9d2a051cad412d";